import { BetSlipMappingResponse, IframeSelectionPayload } from "../common/types";
import { getLocale } from "../common/utils";
import { logger } from "./logger";

export class GtpService {
  private getEndpoint(): string {
    const locale = getLocale();

    const DOMAIN_MAP: Record<string, string> = {
      'es-es': 'transact.williamhill.es',
      'en-gb': 'transact.williamhill.com',
    };

    const domain = DOMAIN_MAP[locale] ?? 'transact.williamhill.com';
    return `https://${domain}/betslip/public/api/v1/mappings/ob-to-gtp`;
  }

  public getBetSlipMapping = async (payload: IframeSelectionPayload): Promise<BetSlipMappingResponse> => {
    if (!payload.byoSelectionDetails || !payload.legacyEventId) {
      throw new Error("AddToBetSlip: wrong paylad: " + JSON.stringify(payload));
    }

    const eventId = payload.legacyEventId;
    const selections = payload.byoSelectionDetails?.map((selection) => ({
      marketId: selection.marketId,
      selectionId: selection.legacySelectionId,
    }));

    const response = await fetch(this.getEndpoint(), {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        eventId,
        selections,
      }),
    });
    const data = await response.json();
    logger.log(`[${GtpService.name}] GTP response: `, data);
    if (!response.ok) {
      throw new Error(`BetSlipMapping(${data.error.errorCode}): ${data.error.errorReason}`);
    }
    logger.log(`[${GtpService.name}] GTP mapping: `, data);

    return data;
  };
}
